import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as firebase from 'firebase';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { connect } from 'react-redux';
// import MegaMenu from 'modules/common/MegaMenu.component';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import RouterBreadcrumbs from 'modules/common/breadcrumbs.component';
import classNames from 'classnames';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AppBar,
  Divider,
  Drawer,
  // IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Tooltip,
  Typography,
  withStyles
} from '@material-ui/core';
// import { Menu } from '@material-ui/icons';

import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS, DRAWER_WIDTH_OPEN, DRAWER_WIDTH_OPEN_MAX, DRAWER_WIDTH_OPEN_MIN } from 'styles/theme';
import { GET_USER_PROFILE_SUCCESS } from 'modules/auth/types';
import { IMPORT_TOOL_BREADCRUMB_LINKS, IMPORT_TOOL_ROUTE } from 'modules/importTool/importTool.constants';
import { getUserProfile } from 'modules/auth/auth.actions';
import AuthorizationDetailsView from 'modules/authorizations/details/authorizationsDetailsView.container';
import AuthorizationsView from 'modules/authorizations/authorizations.container';
import ExpenseSummariesView from 'modules/expenses/expense/expenses.container';
import ImportVoucherFilesView from 'modules/authorizations/import/importVoucherFiles.components';
import ClientsDetailsView from 'modules/clients/details/clientDetailsView.container';
import ClientsView from 'modules/clients/clients.container';
import ImportToolLayout from 'modules/importTool/importTool.layout';
import IntakeRecordDetailsView from 'modules/intake/details/IntakeRecordDetailsView.container';
import IntakeRecordsView from 'modules/intake/summary/intakeRecords.container';
import PasswordResetDialog from 'modules/auth/passwordResetDialog.component';
import auth from 'auth/auth';
import visitor from 'utilities/visitor';

import { GET_FIREBASE_TOKEN_SUCCESS } from 'index.types';
import { GET_RELOCATION_CONSULTANTS_FAILURE } from 'modules/common/store/types';
import { IMPORT_INTAKE_RECORD_SUCCESS } from 'modules/intake/types';
import { TOAST_MESSAGE_SEVERITY_ERROR } from './types';
import { TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { cachedWithRouteOnEnter } from 'modules/common/withRouteOnEnter.component';
import { getApiVersion, hideSideDrawer, showSideDrawer, showToast } from './layout.actions';
import { getFirebaseToken } from 'index.actions';
import { getIntakeSummaries, importIntakeRecord } from 'modules/intake/intake.actions';
import { getRelocationConsultants } from 'modules/common/common.actions';
import BenefitForm from 'modules/benefit/benefitForm.component';
import BenefitsContainer from 'modules/benefit/benefits.container';
import CandidateServicesView from 'modules/authorizations/details/candidateServices/candidateServicesView.container';
import DestinationServicesBuyerView from 'modules/authorizations/details/destinationServices/destinationServicesView.container';
import DestinationServicesRenterView from 'modules/authorizations/details/destinationServices/destinationServicesRenter.container';
import HouseholdGoodsView from 'modules/authorizations/details/hhg/householdGoodsView.container';
import ImportIntakeRecordDialog from 'modules/intake/importIntakeRecordDialog.component';
import ReferentialDataManagementView from 'modules/dataManagement/referentialDataManagement.container';
import SelfServiceContainer from 'modules/selfService/selfService.container';
import SelfServiceDetailsContainer from 'modules/selfService/details/selfServiceDetails.container';
import TaxAssistanceView from 'modules/authorizations/details/taxAssistanceView.container';
import withWidth from '@material-ui/core/withWidth';
import MaintenanceMonitor from 'modules/maintenanceMonitor/maintenanceMonitor.component';
import { sendMaintencanceObjection } from 'modules/maintenanceMonitor/maintenance.actions';

import { Box } from '@mui/material';
import GlobalView from 'modules/authorizations/details/global/globalView.container';
import HomesaleView from 'modules/authorizations/details/homesale/homesaleView.container';
// import SettingsModal from 'modules/authorizations/details/settingsModal.component';

import VendorsView from 'modules/vendors/vendors.container';
import vendorsDetailsView from 'modules/vendors/details/vendorsDetailsView.container';
import CommentsAndNotesView from 'modules/authorizations/details/commentsAndNotes/commentsAndNotesView.container';
import SurveyQuestions from 'modules/surveys/surveyQuestions.container';
import surveyQuestionDetailView from 'modules/surveys/details/surveyQuestionDetailView.container';
import SurveyQuestionResponses from 'modules/surveys/responses/surveyQuestionResponses.container';
import SurveyQuestionResponseDetailsView from 'modules/surveys/responses/surveyQuestionResponseDetailsView.container';
import TempLivingView from 'modules/authorizations/details/tempLiving/tempLivingView.container';
import RecurringPayablesView from 'modules/expenses/recurringPayables/recurringPayables.component';
import voucherDetailsViewContainer from 'modules/expenses/vouchers/details/voucherDetailsView.container';
import expenseDetailsViewContainer from 'modules/expenses/expense/details/expenseDetailsView.container';
import expenseLineItemDetailsViewComponent from 'modules/authorizations/details/expenses/details/expenseLineItemDetailsView.container';
import expensesViewContainer from 'modules/authorizations/details/expenses/expensesView.container';
import VoucherSummariesView from 'modules/expenses/vouchers/vouchers.container';
import recurringPayablesDetailsViewComponent from 'modules/expenses/recurringPayables/details/recurringPayablesDetailsView.component';
import ExpensesView from 'modules/authorizations/details/expenses/expensesView.container';
import ClientCommentsAndNotesView from 'modules/clients/details/commentsAndNotes/commentsAndNotesView.container';
import adminEmailTemplateViewContainer from 'modules/emailTemplates/adminEmailTemplate/adminEmailTemplateView.container';
import adminEmailTemplateDetailsViewComponent from 'modules/emailTemplates/adminEmailTemplate/adminEmailTemplateDetailsView.component';
import pendingAuthsContainer from 'modules/authorizations/pendingAuths.container';
import AuthorizationActivityLogView from 'modules/activityLog/authorizationActivityLogView.component';
import templateActivityLogComponent from 'modules/activityLog/templateActivityLog.component';
import recurringPayableActivityLogViewComponent from 'modules/activityLog/recurringPayableActivityLogView.component';
import clientActivityLogViewComponent from 'modules/activityLog/clientActivityLogView.component';
import vendorActivityLogViewComponent from 'modules/activityLog/vendorActivityLogView.component';
import voucherActivityLogViewComponent from 'modules/activityLog/voucherActivityLogView.component';
import SurveyActivityLogViewComponent from 'modules/activityLog/surveyActivityLog.component';
import expenseActivityLogViewComponent from 'modules/activityLog/expenseActivityLogView.component';
import CsmDashboardContainer from 'modules/csmDashboard/csmDashboard.container';
import DashboardContainer from 'modules/dashboard/dashboard.container';
import OpsManagerDashboardView from 'modules/opsManagerDashboard/opsManagerDashboard.container';
import EaDashboardContainer from 'modules/eaDashboard/eaDashboard.container';
import ExpenseManagerDashboardContainer from 'modules/expenseManagerDashboard/expenseManagerDashboard.container';
import TaskRulesListView from 'modules/taskRules/ruleList.container';
import TaskRulesFormView from 'modules/taskRules/ruleForm.container';
import FeeSummariesView from 'modules/fees/fees.container';
import FeeDetailsView from 'modules/fees/details/feeDetailsView.container';
import acumaticaLogsViewContainer from 'modules/acumaticaLogs/acumaticaLogsView.container';
import ApprovedLineItemSummariesView from 'modules/expenses/approvedLinesSummaries/approvedLineSummariesView.component';
import InternalMultiClientUsersView from 'modules/clients/internalMultiClientUsers/internalMultiClientUsersView.container';
import ClientContactsMigrationView from 'modules/migration/clientUsers/clientContactsMigrationView.container';

const styles = theme => ({
  root: {
    display: 'flex',
    height: '100%'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: DRAWER_WIDTH_OPEN,
    width: `calc(100% - ${DRAWER_WIDTH_OPEN})`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: DRAWER_WIDTH_OPEN,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    minWidth: `${DRAWER_WIDTH_OPEN_MIN}px !important`,
    maxWidth: `${DRAWER_WIDTH_OPEN_MAX}px !important`
  },
  drawerOpen: {
    width: DRAWER_WIDTH_OPEN,
    minWidth: `${DRAWER_WIDTH_OPEN_MIN}px !important`,
    maxWidth: `${DRAWER_WIDTH_OPEN_MAX}px !important`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: DRAWER_WIDTH_CLOSED_XS,
    maxWidth: '200px !important',
    minWidth: '90px !important',
    [theme.breakpoints.up('sm')]: {
      width: DRAWER_WIDTH_CLOSED
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar
  },
  authorizationsToolbar: {
    display: 'flex',
    alignItems: 'right',
    justifyContent: 'space-between',
    minWidth: '100%'
  },
  authorizationsToolbarMenuItems: {
    display: 'flex',
    justifyContent: 'row',
    marginTop: '7px'
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  menuIconRoot: {
    margin: 0,
    justifyContent: 'center',
    marginRight: theme.spacing(2),
    minWidth: 'unset',
    width: theme.spacing(3) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(5) + 1
    }
  },
  menuIconSelected: {
    color: theme.palette.primary.main
  },
  menuList: {
    flexGrow: 2.5,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%'
  },
  nestedMenuList: {
    flexGrow: 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    // Cancel AccordionDetails' side padding so child items span the full nav width.
    marginLeft: `${-theme.spacing(2)}px !important`,
    marginRight: `${-theme.spacing(2)}px !important`,
  },
  versionItem: {
    justifyContent: 'center',
  },
  versionInfoIcon: {
    marginLeft: theme.spacing(0.5),
    fontSize: '1rem',
    color: theme.palette.text.secondary,
    cursor: 'help',
  },
});

const SESSION_RENEWAL_INTERVAL = 3600000; // one hour

// Detail pages outside the authorization/client/partner/fee sections that get the record-detail toolbar
const DETAIL_TOOLBAR_PATHS = [
  '/expenses/',
  '/vouchers/',
  '/recurringPayables/',
  '/surveyQuestions/',
  '/templates/',
  '/surveyQuestionResponses/',
  '/approvedLineItemReports/',
];

// Exactly one AppBar toolbar renders per page. Checks are ordered so that when a path
// belongs to more than one section (e.g. an expense nested under an authorization),
// the first matching section owns the breadcrumbs.
const resolveActiveToolbar = pathname => {
  if (pathname.startsWith(IMPORT_TOOL_ROUTE)) return 'importTool';
  if (pathname.includes('/authorizations/')) return 'authorizations';
  if (pathname.includes('/clients/')) return 'clients';
  if (pathname.includes('/partners/')) return 'partners';
  if (pathname.includes('/fees/')) return 'fees';
  if (DETAIL_TOOLBAR_PATHS.some(path => pathname.includes(path))) return 'details';
  return 'title';
};

class AuthenticatedRoutes extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showPasswordReset: false,
      passwordResetError: null,
      isSubmittingPasswordReset: false,
      showImport: false,
      importError: null
    };
    this.renewSessionHandle = null;
  }

  async componentDidMount() {
    // TODO handle failure case
    let { type, response } = await this.props.getUserProfile();
    if (type === GET_USER_PROFILE_SUCCESS) {
      visitor.set('uid', response.email);
      localStorage.setItem('username', response.moveTrackUsername);
    }
    await this.props.getApiVersion();
    await this.authenticateWithFirebase();
    this.initSessionTimers();
  }

  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this.renewSessionWhenVisible, false);
    clearInterval(this.renewSessionHandle);
  }

  authenticateWithFirebase = async () => {
    const tokenResult = await this.props.getFirebaseToken();
    if (tokenResult.type === GET_FIREBASE_TOKEN_SUCCESS) {
      await firebase.auth().signInWithCustomToken(tokenResult.response);
    }
  };

  initSessionTimers = () => {
    document.addEventListener('visibilitychange', this.renewSessionWhenVisible, false);
    this.renewSessionHandle = setInterval(() => {
      this.renewSession();
    }, SESSION_RENEWAL_INTERVAL);
  };

  renewSessionWhenVisible = ({ target }) => {
    if (target.visibilityState === 'visible') {
      this.renewSession();
    }
  };

  renewSession = async () => {
    const { history } = this.props;
    const wasRenewed = await auth.renewSession();
    if (!wasRenewed) {
      history.replace('/login', {
        from: { pathname: history.pathname }
      });
    }
  };

  navigate = path => {
    this.props.history.push(path);
  };

  handlePasswordResetRequest = async () => {
    this.setState({ passwordResetError: null, isSubmittingPasswordReset: true });
    try {
      const { email } = this.props.profile;
      await auth.requestPasswordReset(email);
      this.setState({ isSubmittingPasswordReset: false, showPasswordReset: false });
      this.props.showToast('Success! Please check your email for reset instructions');
    } catch (err) {
      this.setState({
        isSubmittingPasswordReset: false,
        passwordResetError: 'Something went wrong, please try again'
      });
    }
  };

  handleImportRequest = async authId => {
    this.setState({ importError: null });

    const { type } = await this.props.importIntakeRecord(authId);
    if (type === IMPORT_INTAKE_RECORD_SUCCESS) {
      this.setState({ showImport: false });
      this.props.showToast('Successfully imported auth file!', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });

      if (auth.userHasRole('Task.Admin')) {
        let getConsultantsAction = await this.props.getRelocationConsultants();
        if (getConsultantsAction.type === GET_RELOCATION_CONSULTANTS_FAILURE) {
          this.props.showToast('Failed to retrieve data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }
      }

      this.props.getIntakeSummaries();
    } else {
      this.props.showToast('Failed to retrieve data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }
  };

  onRouteEnter = () => {
    const authorized = auth.isPathAuthorized(this.props.location.pathname);
    if (!authorized) {
      this.props.history.push('/');
    }
  };

  navigationItems = [
    {
      title: 'Dashboard',
      // icon: ['fas', 'chart-gantt'],
      selected: false,
      children: [
        {
          title: 'RC Dashboard',
          route: '/dashboard'
          // icon: ['fas', 'chart-line'],
        },
        {
          title: 'EA Dashboard',
          route: '/ea-dashboard'
          // icon: ['fas', 'file-invoice-dollar'],
        },
        {
          title: 'EA Manager Dashboard',
          route: '/expense-manager-dashboard',
        },
        {
          title: 'Ops Manager Dashboard',
          route: '/ops-manager-dashboard'
          // icon: ['fas', 'users-cog']
        },
        {
          title: 'CSM Dashboard',
          route: '/csm-dashboard'
        }
      ]
    },
    {
      title: 'Transferees',
      // icon: ['fas', 'user-check'],
      selected: false,
      children: [
        {
          title: 'Intake Records',
          route: '/intakeRecords'
          // icon: ['fas', 'right-to-bracket']
        },
        {
          title: 'Authorizations',
          route: '/authorizations'
          // icon: ['far', 'id-badge']
        },
        {
          title: 'Pending Auths',
          route: '/pendingAuths'
          // icon: ['fas', 'people-arrows']
        },
        {
          title: 'Import Data',
          route: IMPORT_TOOL_ROUTE
          // icon: ['fas', 'file-import']
        }
      ]
    },
    {
      title: 'Finance',
      // icon: ['fas', 'building-columns'],
      selected: false,
      children: [
        {
          title: 'Expenses',
          route: '/expenses'
          // icon: ['fas', 'money-bills']
        },
        {
          title: 'Vouchers',
          route: '/vouchers'
          // icon: ['fas', 'money-check-alt']
        },
        {
          title: 'Import Voucher Files',
          route: '/importVouchers'
          // icon: ['fas', 'file-import']
        },
        {
          title: 'Recurring Payables',
          route: '/recurringPayables'
          // icon: ['fas', 'file-invoice-dollar']
        },
        {
          title: 'Partners',
          route: '/partners'
          // icon: ['fas', 'address-book']
        },
        {
          title: 'Fees',
          route: '/fees'
          // icon: ['fas', 'money-check']
        },
        {
          title: 'Approved Lines',
          route: '/approvedLineItemReports'
          // icon: ['fas', 'file-invoice-dollar']
        }
      ]
    },
    {
      title: 'Clients',
      // icon: ['fas', 'user-friends'],
      route: '/clients',
      selected: false
      // children: [
      //   {
      //     title: 'Clients',

      //     icon: ['fas', 'user-friends']
      //   }
      // ]
    },
    {
      title: 'Admin',
      // icon: ['fas', 'cogs'],
      selected: false,
      children: [
        {
          title: 'Task Rules',
          route: '/admin/task-rules'
          // icon: ['fas', 'tasks']
        },
        {
          title: 'Templates',
          route: '/templates'
          // icon: ['fas', 'file-contract']
        },
        {
          title: 'Survey Questions',
          route: '/surveyQuestions'
          // icon: ['fas', 'question-circle']
        },
        {
          title: 'Question Responses',
          route: '/surveyQuestionResponses'
          // icon: ['fas', 'reply']
        },
        {
          title: 'Data Management',
          route: '/dataManagement'
          // icon: ['fas', 'database']
        },
        {
          title: 'Acumatica Logs',
          route: '/acumaticaLogs'
          // icon: ['fas', 'tasks']
        },
        {
          title: 'Reset Password'
          // icon: ['fas', 'key'],
        },
        {
          title: 'Logout',
          route: '/logout',
          icon: ['fas', 'power-off']
        },
        {
          title: 'Internal Client Users',
          route: '/internalMultiClientUsers'
        },
                {
          title: 'Client Users Migration',
          route: '/migration/clientUsers'
        }
      ]
    }
    // {
    //   title: 'Benefits',
    //   route: '/benefits',
    //   requiredPermission: 'selfService:write:benefits',
    //   icon: ['fas', 'ballot']
    // },
    // {
    //   title: 'Self Service',
    //   route: '/selfService',
    //   requiredPermission: 'selfService:read:auths',
    //   icon: ['fas', 'concierge-bell']
    // },
  ];

  render() {
    const {
      classes,
      theme,
      title,
      // shouldShowSideDrawer,
      profile,
      isImportingRecord,
      apiVersion,
      location,
      currentAuthId,
      currentClientId,
      clientsInfo,
      authorizationDetails,
      currentSurveyQuestionId,
      currentTemplateId,
      currentVendorId,
      voucherId,
      expenseId,
      recurringPayableId
    } = this.props;
    const { showPasswordReset, passwordResetError, isSubmittingPasswordReset, showImport, importError } = this.state;

    // const screenIsXl = this.props.width === 'xl';
    // const sideDrawerAvailable = screenIsXl && shouldShowSideDrawer;
    const sideDrawerAvailable = true;
    const activeToolbar = resolveActiveToolbar(location.pathname);
    const authInfo = authorizationDetails?.[currentAuthId]?.authorizationDetails;
    const personalInfo =
      authorizationDetails?.[currentAuthId]?.familyMembers?.find(
        f => f.familyRelationshipTypeId === '83ff7cbb-6ec5-4162-a449-9205b0e5c921'
      ) || {};

    const clientInfo = clientsInfo?.[currentClientId]?.clientDetails?.clientDetails;

    const friendlyLinks = [
      {
        link: '/authorizations',
        name: 'Authorizations'
      },
      {
        link: '/pendingAuths',
        name: 'Pending Auths'
      },
      {
        link: '/clients',
        name: 'Clients'
      },
      {
        link: `/clients/${currentClientId}`,
        name: clientInfo && clientInfo.shortName ? clientInfo.shortName : currentClientId
      },
      {
        link: `/clients/${currentClientId}/comments`,
        name: 'Comments'
      },
      {
        short: '/log',
        name: 'Activity Log'
      },
      {
        short: '/comments',
        name: 'Comments'
      },
      {
        short: '/taxAssistance',
        name: 'Tax Assistance'
      },
      {
        short: '/renterServices',
        name: 'Destination Services: Renter'
      },
      {
        short: '/buyerServices',
        name: 'Destination Services: Buyer'
      },
      {
        short: '/candidateServices',
        name: 'Candidate/Intern Services'
      },
      {
        short: '/hhg',
        name: 'Household Goods'
      },
      {
        short: '/tempLiving',
        name: 'Temporary Living'
      },
      {
        short: '/global',
        name: 'Global'
      },
      {
        short: '/homesale',
        name: 'Homesale'
      },
      {
        short: '/expenses',
        name: 'Expenses'
      },
      {
        short: '/recurringPayments',
        name: 'Recurring Payments'
      },
      {
        short: '/partners',
        name: 'Partners'
      },
      {
        short: '/surveyQuestions',
        name: 'Survey Questions'
      },
      {
        short: '/surveyQuestionResponses',
        name: 'Survey Question Responses'
      },
      {
        short: '/templates',
        name: 'Templates'
      },
      {
        short: `${currentAuthId}`,
        name: authInfo && personalInfo ? `${personalInfo.firstName} ${personalInfo.lastName} (${authInfo.fileNumber})` : currentAuthId
      },
      {
        short: '/acumaticaLogs',
        name: 'Acumatica Logs'
      }
    ];

    // Names for the breadcrumb segments of record-detail pages. The section names use exact `link`
    // matches so the id segment that follows is never relabeled; the trailing activity log segment
    // is matched as a whole segment via `short`.
    const detailsToolbarLinks = [
      {
        short: '/log',
        name: 'Activity Log',
      },
      {
        link: '/expenses',
        name: 'Expenses',
      },
      {
        link: '/vouchers',
        name: 'Vouchers',
      },
      {
        link: '/recurringPayables',
        name: 'Recurring Payables',
      },
      {
        link: '/partners',
        name: 'Partners',
      },
      {
        link: '/templates',
        name: 'Templates',
      },
      {
        link: '/surveyQuestions',
        name: 'Survey Questions',
      },
      {
        link: '/surveyQuestionResponses',
        name: 'Survey Question Responses',
      },
    ];

    // const quickLinksMenuTitle = [
    //   {
    //     name: 'Quick Links',
    //     color: 'white !important',
    //     variant: 'h6',
    //     fontSize: '1.0714285714285714rem !important',
    //     icon: ['fas', 'fa-bars']
    //   }
    // ];

    // const settingsLinks = [
    //   {
    //     link: '/activityCalendar',
    //     name: 'Activity Calendar'
    //   },
    //   {
    //     link: '/banking',
    //     name: 'Banking'
    //   },
    //   {
    //     link: '/cola',
    //     name: 'COLA'
    //   },
    //   {
    //     link: '/documents',
    //     name: 'Documents'
    //   },
    //   {
    //     link: '/family',
    //     name: 'Family'
    //   },
    //   {
    //     link: '/letters',
    //     name: 'Letters'
    //   },
    //   {
    //     link: '/mida',
    //     name: 'MIDA'
    //   },
    //   {
    //     link: '/Needs',
    //     name: 'Needs'
    //   },
    //   {
    //     link: '/otherServices',
    //     name: 'Other Services'
    //   },
    //   {
    //     link: '/referrals',
    //     name: 'Referrals'
    //   },
    //   {
    //     link: '/survey',
    //     name: 'Survey'
    //   },
    //   {
    //     link: '/tasks',
    //     name: 'Tasks'
    //   },
    //   {
    //     link: '/tenancy',
    //     name: 'Tenancy'
    //   },
    //   {
    //     link: '/userData',
    //     name: 'User Data'
    //   },
    //   {
    //     link: '/vendorPerformance',
    //     name: 'Vendor Performance'
    //   }
    // ];

    // const taxServiceQuickLinks = [
    //   {
    //     link: '/advances',
    //     name: 'Advances'
    //   },
    //   {
    //     link: '/expenses',
    //     name: 'Expenses'
    //   },
    //   {
    //     link: '/salary',
    //     name: 'Salary'
    //   },
    //   {
    //     link: '/travel',
    //     name: 'Travel'
    //   },
    //   {
    //     link: '/exceptions',
    //     name: 'Exceptions'
    //   },
    //   {
    //     link: '/budgets',
    //     name: 'Budgets'
    //   },
    //   {
    //     link: '/taxes',
    //     name: 'Taxes'
    //   },
    //   {
    //     link: '/custom',
    //     name: 'Custom'
    //   }
    // ];

    // const temporaryLivingLinks = [
    //   {
    //     link: '/letters',
    //     name: 'Letters'
    //   },
    //   {
    //     link: '/exceptions',
    //     name: 'Exceptions'
    //   }
    // ];

    // const resolveQuickLinks = () => {
    //   if (window.location.href.includes('taxAssistance')) {
    //     return taxServiceQuickLinks;
    //   } else if (window.location.href.includes('tempLiving')) {
    //     return temporaryLivingLinks;
    //   }

    //   return settingsLinks;
    // };

    const formatToolbarDate = value => {
      if (!value) {
        return 'N/A';
      }

      const parsedDate = new Date(value);
      if (Number.isNaN(parsedDate.getTime())) {
        return value;
      }

      return parsedDate.toLocaleDateString();
    };

    const lastRcCommentDate = authorizationDetails && authorizationDetails[currentAuthId]?.lastRCCommentDate ? authorizationDetails[currentAuthId]?.lastRCCommentDate : null;
    const lastRcActionDate = authorizationDetails && authorizationDetails[currentAuthId]?.lastRCActionDate ? authorizationDetails[currentAuthId]?.lastRCActionDate : null;

    return (
      <div className={classes.root}>
        <AppBar
          position="fixed"
          className={classNames(classes.appBar, {
            [classes.appBarShift]: sideDrawerAvailable
          })}
        >
          {activeToolbar === 'authorizations' && (
            <>
              <Toolbar disableGutters={!sideDrawerAvailable}>
                {/* {screenIsXl ? (
                  <IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    onClick={this.props.showSideDrawer}
                    className={classNames(classes.menuButton, {
                      [classes.hide]: sideDrawerAvailable
                    })}
                  >
                    <Menu />
                  </IconButton>
                ) : ( */}
                <div style={{ marginRight: 20 }} />
                {/* )} */}
                <div className={classes.authorizationsToolbar}>
                  <RouterBreadcrumbs friendlyLinks={friendlyLinks} />
                  <div className={classes.authorizationsToolbarMenuItems}>
                    <Box
                      onClick={() => this.navigate(`/authorizations/${currentAuthId}/comments`)}
                      sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                    >
                      <Typography variant="h6" color="inherit" noWrap style={{ marginRight: '7px' }}>
                        Comments
                      </Typography>
                      <FontAwesomeIcon
                        size="1x"
                        icon={['fas', 'fa-comment']}
                        color="white"
                        style={{ marginTop: '6px', marginRight: '13px' }}
                      />
                    </Box>
                    <Box
                      onClick={() => this.navigate(`/authorizations/${currentAuthId}/log`)}
                      sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                    >
                      <Typography variant="h6" color="inherit" noWrap style={{ marginRight: '7px' }}>
                        Activity Log
                      </Typography>
                      <FontAwesomeIcon
                        size="1x"
                        icon={['fas', 'fa-clipboard']}
                        color="white"
                        style={{ marginTop: '6px', marginRight: '13px' }}
                      />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', marginRight: '16px' }}>
                      <Typography variant="subtitle2" color="inherit" noWrap>
                        Last RC Comment Date
                      </Typography>
                      <Typography variant="body2" color="inherit" noWrap>
                        {formatToolbarDate(lastRcCommentDate)}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', marginRight: '13px' }}>
                      <Typography variant="subtitle2" color="inherit" noWrap>
                        Last RC Action Date
                      </Typography>
                      <Typography variant="body2" color="inherit" noWrap>
                        {formatToolbarDate(lastRcActionDate)}
                      </Typography>
                    </Box>
                    {/* <MegaMenu menuTitle={quickLinksMenuTitle} menuLinks={resolveQuickLinks()} />
                    {!location.pathname.includes(`/authorizations/${currentAuthId}/`) && (
                      <>
                        <Box sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', marginRight: '25px' }}>
                          <SettingsModal authId={currentAuthId} authDetails={authorizationDetails} />
                        </Box>
                      </>
                    )} */}
                  </div>
                </div>
              </Toolbar>
            </>
          )}
          {activeToolbar === 'clients' && (
            <>
              <Toolbar disableGutters={!sideDrawerAvailable}>
                {/* {screenIsXl ? (
                  <IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    onClick={this.props.showSideDrawer}
                    className={classNames(classes.menuButton, {
                      [classes.hide]: sideDrawerAvailable
                    })}
                  >
                    <Menu />
                  </IconButton>
                ) : ( */}
                <div style={{ marginRight: 20 }} />
                {/* )} */}
                <div className={classes.authorizationsToolbar}>
                  <RouterBreadcrumbs friendlyLinks={friendlyLinks} />
                  <div className={classes.authorizationsToolbarMenuItems}>
                    <Box
                      onClick={() => this.navigate(`/clients/${currentClientId}/comments`)}
                      sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                    >
                      <Typography variant="h6" color="inherit" noWrap style={{ marginRight: '7px' }}>
                        Comments
                      </Typography>
                      <FontAwesomeIcon
                        size="1x"
                        icon={['fas', 'fa-comment']}
                        color="white"
                        style={{ marginTop: '6px', marginRight: '13px' }}
                      />
                    </Box>
                    <Box
                      onClick={() => this.navigate(`/clients/${currentClientId}/log`)}
                      sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                    >
                      <Typography variant="h6" color="inherit" noWrap style={{ marginRight: '7px' }}>
                        Activity Log
                      </Typography>
                      <FontAwesomeIcon
                        size="1x"
                        icon={['fas', 'fa-clipboard']}
                        color="white"
                        style={{ marginTop: '6px', marginRight: '25px' }}
                      />
                    </Box>
                  </div>
                </div>
              </Toolbar>
            </>
          )}
          {activeToolbar === 'partners' && (
            <>
              <Toolbar disableGutters={!sideDrawerAvailable}>
                {/* {screenIsXl ? (
                  <IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    onClick={this.props.showSideDrawer}
                    className={classNames(classes.menuButton, {
                      [classes.hide]: sideDrawerAvailable
                    })}
                  >
                    <Menu />
                  </IconButton>
                ) : ( */}
                <div style={{ marginRight: 20 }} />
                {/* )} */}
                <div className={classes.authorizationsToolbar}>
                  <RouterBreadcrumbs friendlyLinks={detailsToolbarLinks} />
                  <div className={classes.authorizationsToolbarMenuItems}>
                    <Box
                      onClick={() => this.navigate(`/partners/${currentVendorId}/log`)}
                      sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                    >
                      <Typography variant="h6" color="inherit" noWrap style={{ marginRight: '7px' }}>
                        Activity Log
                      </Typography>
                      <FontAwesomeIcon
                        size="1x"
                        icon={['fas', 'fa-clipboard']}
                        color="white"
                        style={{ marginTop: '6px', marginRight: '25px' }}
                      />
                    </Box>
                  </div>
                </div>
              </Toolbar>
            </>
          )}
          {activeToolbar === 'fees' && (
            <>
              <Toolbar disableGutters={!sideDrawerAvailable}>
                {/* {screenIsXl ? (
                  <IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    onClick={this.props.showSideDrawer}
                    className={classNames(classes.menuButton, {
                      [classes.hide]: sideDrawerAvailable
                    })}
                  >
                    <Menu />
                  </IconButton>
                ) : ( */}
                <div style={{ marginRight: 20 }} />
                {/* )} */}
                <div className={classes.authorizationsToolbar}>
                  <RouterBreadcrumbs friendlyLinks={friendlyLinks} />
                  <div className={classes.authorizationsToolbarMenuItems}></div>
                </div>
              </Toolbar>
            </>
          )}
          {activeToolbar === 'importTool' && (
            <Toolbar disableGutters={!sideDrawerAvailable}>
              <div style={{ marginRight: 20 }} />
              <RouterBreadcrumbs friendlyLinks={IMPORT_TOOL_BREADCRUMB_LINKS} />
            </Toolbar>
          )}
          {activeToolbar === 'title' && (
            <>
              <Toolbar disableGutters={!sideDrawerAvailable}>
                {/* {screenIsXl ? (
                  <IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    onClick={this.props.showSideDrawer}
                    className={classNames(classes.menuButton, {
                      [classes.hide]: sideDrawerAvailable
                    })}
                  >
                    <Menu />
                  </IconButton>
                ) : ( */}
                <div style={{ marginRight: 20 }} />
                {/* )} */}
                <Typography variant="h6" color="inherit" noWrap>
                  {title}
                </Typography>
              </Toolbar>
            </>
          )}
          {activeToolbar === 'details' && (
            <>
              <Toolbar disableGutters={!sideDrawerAvailable}>
                {/* {screenIsXl ? (
                  <IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    onClick={this.props.showSideDrawer}
                    className={classNames(classes.menuButton, {
                      [classes.hide]: sideDrawerAvailable
                    })}
                  >
                    <Menu />
                  </IconButton>
                ) : ( */}
                <div style={{ marginRight: 20 }} />
                {/* )} */}
                <div className={classes.authorizationsToolbar}>
                  <RouterBreadcrumbs friendlyLinks={detailsToolbarLinks} />
                  <div className={classes.authorizationsToolbarMenuItems}>
                    {location.pathname.includes('/expenses/') && (
                      <Box
                        onClick={() => this.navigate(`/expenses/${expenseId}/log`)}
                        sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                      >
                        <Typography variant="h6" color="inherit" noWrap style={{ marginRight: '7px' }}>
                          Activity Log
                        </Typography>
                        <FontAwesomeIcon
                          size="1x"
                          icon={['fas', 'fa-clipboard']}
                          color="white"
                          style={{ marginTop: '6px', marginRight: '25px' }}
                        />
                      </Box>
                    )}
                    {location.pathname.includes('/vouchers/') && (
                      <Box
                        onClick={() => this.navigate(`/vouchers/${voucherId}/log`)}
                        sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                      >
                        <Typography variant="h6" color="inherit" noWrap style={{ marginRight: '7px' }}>
                          Activity Log
                        </Typography>
                        <FontAwesomeIcon
                          size="1x"
                          icon={['fas', 'fa-clipboard']}
                          color="white"
                          style={{ marginTop: '6px', marginRight: '25px' }}
                        />
                      </Box>
                    )}
                    {location.pathname.includes('/recurringPayables/') && (
                      <Box
                        onClick={() => this.navigate(`/recurringPayables/${recurringPayableId}/log`)}
                        sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                      >
                        <Typography variant="h6" color="inherit" noWrap style={{ marginRight: '7px' }}>
                          Activity Log
                        </Typography>
                        <FontAwesomeIcon
                          size="1x"
                          icon={['fas', 'fa-clipboard']}
                          color="white"
                          style={{ marginTop: '6px', marginRight: '25px' }}
                        />
                      </Box>
                    )}
                    {location.pathname.includes('/templates/') && (
                      <Box
                        onClick={() => this.navigate(`/templates/${currentTemplateId}/log`)}
                        sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                      >
                        <Typography variant="h6" color="inherit" noWrap style={{ marginRight: '7px' }}>
                          Activity Log
                        </Typography>
                        <FontAwesomeIcon
                          size="1x"
                          icon={['fas', 'fa-clipboard']}
                          color="white"
                          style={{ marginTop: '6px', marginRight: '25px' }}
                        />
                      </Box>
                    )}
                    {location.pathname.includes('/surveyQuestions/') && (
                      <Box
                        onClick={() => this.navigate(`/surveyQuestions/${currentSurveyQuestionId}/log`)}
                        sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
                      >
                        <Typography variant="h6" color="inherit" noWrap style={{ marginRight: '7px' }}>
                          Activity Log
                        </Typography>
                        <FontAwesomeIcon
                          size="1x"
                          icon={['fas', 'fa-clipboard']}
                          color="white"
                          style={{ marginTop: '6px', marginRight: '25px' }}
                        />
                      </Box>
                    )}
                  </div>
                </div>
              </Toolbar>
            </>
          )}
        </AppBar>
        <Drawer
          variant="permanent"
          className={classNames(classes.drawer, {
            [classes.drawerOpen]: sideDrawerAvailable,
            [classes.drawerClose]: !sideDrawerAvailable
          })}
          classes={{
            paper: classNames({
              [classes.drawerOpen]: sideDrawerAvailable,
              [classes.drawerClose]: !sideDrawerAvailable
            })
          }}
          open={sideDrawerAvailable}
        >
          <div className={classes.toolbar}>
            {/* <IconButton onClick={this.props.hideSideDrawer}>{theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />}</IconButton> */}
          </div>
          <Divider />
          <List classes={{ root: classes.menuList }}>
            <div>
              {this.navigationItems.map(item => {
                if (item.requiredPermission) {
                  if (!auth.userHasPermission(item.requiredPermission)) {
                    return null;
                  }
                } else if (item.children) {
                  return (
                    <Accordion>
                      <AccordionSummary>
                        {/* <FontAwesomeIcon icon={item.icon} size="3x" style={{ color: theme.palette.grey[600], marginRight: sideDrawerAvailable ? theme.spacing(2) : 0 }} /> */}
                        <Typography
                          variant="h6"
                          style={{ color: theme.palette.grey[600], marginTop: sideDrawerAvailable ? theme.spacing(1) : 0 }}
                        >
                          {item.title}
                        </Typography>
                        <ExpandMoreIcon style={{ color: theme.palette.grey[600], marginTop: '10px' }} />
                      </AccordionSummary>
                      <AccordionDetails>
                        <List classes={{ root: classes.nestedMenuList }}>
                          {item.children.map(child => {
                            const childSelected = location.pathname && location.pathname.startsWith(child.route);
                            if (child.title === 'Reset Password' && profile) {
                              return (
                                <Tooltip title="Reset Password" placement="right">
                                  <ListItem button onClick={() => this.setState({ showPasswordReset: true })}>
                                    {/* <ListItemIcon classes={{ root: classes.menuIconRoot }}>
                                      {/* <FontAwesomeIcon icon={['fas', 'key']} size="2x" />
                                    </ListItemIcon> */}
                                    <ListItemText primary="Reset Password" />
                                  </ListItem>
                                </Tooltip>
                              );
                            } else {
                              return (
                                <Tooltip title={child.title} key={child.title} placement="right">
                                  <ListItem selected={childSelected} button onClick={() => this.navigate(child.route)}>
                                    {/* <ListItemIcon classes={{ root: classes.menuIconRoot }} className={childSelected ? classes.menuIconSelected : ''}>
                                      {/* <FontAwesomeIcon icon={child.icon} size="3x" />
                                    </ListItemIcon> */}
                                    <ListItemText primary={child.title} />
                                  </ListItem>
                                </Tooltip>
                              );
                            }
                          })}
                        </List>
                      </AccordionDetails>
                    </Accordion>
                  );
                } else if (item.title === 'Clients') {
                  const selected = location.pathname && location.pathname.startsWith(item.route);
                  return (
                    <Accordion
                      onClick={() => {
                        this.navigate(item.route);
                      }}
                      expanded={false}
                      style={{ backgroundColor: selected ? theme.palette.grey[200] : 'transparent' }}
                    >
                      <AccordionSummary>
                        {/* <FontAwesomeIcon icon={item.icon} size="3x" style={{ color: selected ? theme.palette.primary.main :theme.palette.grey[600], marginRight: sideDrawerAvailable ? theme.spacing(2) : 0 }} /> */}
                        <Typography
                          variant="h6"
                          style={{ color: theme.palette.grey[600], marginTop: sideDrawerAvailable ? theme.spacing(1) : 0 }}
                        >
                          {item.title}
                        </Typography>
                      </AccordionSummary>
                    </Accordion>
                  );
                } else {
                  const selected = location.pathname && location.pathname.startsWith(item.route);
                  return (
                    <Tooltip title={item.title} key={item.title} placement="right">
                      <ListItem selected={selected} button onClick={() => this.navigate(item.route)}>
                        <ListItemIcon classes={{ root: classes.menuIconRoot }} className={selected ? classes.menuIconSelected : ''}>
                          {/* <FontAwesomeIcon icon={item.icon} size="3x" /> */}
                        </ListItemIcon>
                        <ListItemText variant="h6" style={{ fontWeight: 'bold' }} primary={item.title} />
                      </ListItem>
                    </Tooltip>
                  );
                }
                return null;
              })}
            </div>
            <div>
              {/* {auth.userHasRole('admin') && (
                <Tooltip title="Import Auth File" placement="right">
                  <ListItem button onClick={() => this.setState({ showImport: true })}>
                    <ListItemIcon classes={{ root: classes.menuIconRoot }}>
                      <FontAwesomeIcon icon={['fas', 'file-import']} size="2x" />
                    </ListItemIcon>
                    <ListItemText primary="Import Auth File" />
                  </ListItem>
                </Tooltip>
              )} */}
              {/* {profile && (
                <Tooltip title="Reset Password" placement="right">
                  <ListItem button onClick={() => this.setState({ showPasswordReset: true })}>
                    <ListItemIcon classes={{ root: classes.menuIconRoot }}>
                      <FontAwesomeIcon icon={['fas', 'key']} size="2x" />
                    </ListItemIcon>
                    <ListItemText primary="Reset Password" />
                  </ListItem>
                </Tooltip>
              )}
              <Tooltip title="Logout" placement="right">
                <ListItem button onClick={() => this.navigate('/logout')}>
                  <ListItemIcon classes={{ root: classes.menuIconRoot }}>
                    <FontAwesomeIcon icon={['fas', 'power-off']} size="2x" />
                  </ListItemIcon>
                  <ListItemText primary="Logout" />
                </ListItem>
              </Tooltip> */}
              <ListItem dense disableGutters classes={{ root: classes.versionItem }}>
                <Typography variant="body2">RIOT v{process.env.REACT_APP_VERSION}</Typography>
                {apiVersion && (
                  <Tooltip title={`API build ${apiVersion}`} placement="right">
                    <InfoOutlinedIcon className={classes.versionInfoIcon} />
                  </Tooltip>
                )}
              </ListItem>
            </div>
          </List>
        </Drawer>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <MaintenanceMonitor sendMaintencanceObjection={this.props.sendMaintencanceObjection} showToast={this.props.showToast} />
          <Switch>
            <Route exact path="/dashboard" component={DashboardContainer} />
            <Route exact path="/ea-dashboard" component={EaDashboardContainer} />
            <Route exact path="/expense-manager-dashboard" component={ExpenseManagerDashboardContainer} />
            <Route exact path="/ops-manager-dashboard" component={OpsManagerDashboardView} />
            <Route exact path="/csm-dashboard" component={CsmDashboardContainer} />
            <Route exact path="/admin/task-rules" component={TaskRulesListView} />
            <Route exact path="/admin/task-rules/create" component={TaskRulesFormView} />
            <Route exact path="/admin/task-rules/edit/:id" component={TaskRulesFormView} />
            <Route exact path="/intakeRecords" component={IntakeRecordsView} />
            <Route exact path="/intakeRecords/:id" component={IntakeRecordDetailsView} />
            <Route exact path="/authorizations" component={AuthorizationsView} />
            <Route exact path="/authorizations/:id" component={AuthorizationDetailsView} />
            <Route exact path="/authorizations/:id/log" component={AuthorizationActivityLogView} />
            <Route exact path="/authorizations/:id/taxAssistance" component={TaxAssistanceView} />
            <Route exact path="/authorizations/:id/tempLiving" component={TempLivingView} />
            <Route exact path="/authorizations/:id/buyerServices" component={DestinationServicesBuyerView} />
            <Route exact path="/authorizations/:id/renterServices" component={DestinationServicesRenterView} />
            <Route exact path="/authorizations/:id/candidateServices" component={CandidateServicesView} />
            <Route exact path="/authorizations/:id/hhg" component={HouseholdGoodsView} />
            <Route exact path="/authorizations/:id/global" component={GlobalView} />
            <Route exact path="/authorizations/:id/homesale" component={HomesaleView} />
            <Route exact path="/authorizations/:id/expenses" component={ExpensesView} />
            <Route exact path="/authorizations/:id/expenses/approved" component={expensesViewContainer} />
            <Route exact path="/authorizations/:id/expenses/:expenseId" component={expenseDetailsViewContainer} />
            <Route exact path="/authorizations/:id/expenses/approved/:expenseLineId" component={expenseLineItemDetailsViewComponent} />
            <Route exact path="/pendingAuths" component={pendingAuthsContainer} />
            <Route path={IMPORT_TOOL_ROUTE} component={ImportToolLayout} />
            <Route exact path="/expenses" component={ExpenseSummariesView} />
            <Route exact path="/expenses/:expenseId" component={expenseDetailsViewContainer} />
            <Route exact path="/vouchers" component={VoucherSummariesView} />
            <Route exact path="/importVouchers" component={ImportVoucherFilesView} />
            <Route exact path="/vouchers/:voucherId" component={voucherDetailsViewContainer} />
            <Route exact path="/fees" component={FeeSummariesView} />
            <Route exact path="/fees/:feeRecordId" component={FeeDetailsView} />
            <Route exact path="/partners" component={VendorsView} />
            <Route exact path="/partners/:id" component={vendorsDetailsView} />
            <Route exact path="/clients" component={ClientsView} />
            <Route exact path="/clients/:id" component={ClientsDetailsView} />
            <Route exact path="/clients/:id/comments" component={ClientCommentsAndNotesView} />
            <Route exact path="/benefits" component={cachedWithRouteOnEnter(BenefitsContainer, this.onRouteEnter)} />
            <Route exact path="/benefits/add" component={cachedWithRouteOnEnter(BenefitForm, this.onRouteEnter)} />
            <Route exact path="/benefits/:id/v/:versionId" component={cachedWithRouteOnEnter(BenefitForm, this.onRouteEnter)} />
            <Route exact path="/selfService" component={cachedWithRouteOnEnter(SelfServiceContainer, this.onRouteEnter)} />
            <Route exact path="/selfService/:authId" component={cachedWithRouteOnEnter(SelfServiceDetailsContainer, this.onRouteEnter)} />
            <Route exact path="/dataManagement" component={ReferentialDataManagementView} />
            <Route exact path="/authorizations/:id/comments" component={CommentsAndNotesView} />
            <Route exact path="/recurringPayables" component={RecurringPayablesView} />
            <Route exact path="/recurringPayables/:recurringPayableId" component={recurringPayablesDetailsViewComponent} />
            <Route exact path="/surveyQuestions" component={SurveyQuestions} />
            <Route exact path="/surveyQuestions/:surveyQuestionId" component={surveyQuestionDetailView} />
            <Route exact path="/surveyQuestionResponses" component={SurveyQuestionResponses} />
            <Route exact path="/surveyQuestionResponses/:responseId" component={SurveyQuestionResponseDetailsView} />
            <Route exact path="/templates" component={adminEmailTemplateViewContainer} />
            <Route exact path="/templates/:templateId" component={adminEmailTemplateDetailsViewComponent} />

            <Route exact path="/expenses/:expenseId/log" component={expenseActivityLogViewComponent} />
            <Route exact path="/templates/:templateId/log" component={templateActivityLogComponent} />
            <Route exact path="/recurringPayables/:recurringPayableId/log" component={recurringPayableActivityLogViewComponent} />
            <Route exact path="/clients/:clientId/log" component={clientActivityLogViewComponent} />
            <Route exact path="/partners/:vendorId/log" component={vendorActivityLogViewComponent} />
            <Route exact path="/vouchers/:voucherId/log" component={voucherActivityLogViewComponent} />
            <Route exact path="/surveyQuestions/:surveyId/log" component={SurveyActivityLogViewComponent} />
            <Route exact path="/acumaticaLogs" component={acumaticaLogsViewContainer} />

            <Route exact path="/approvedLineItemReports" component={ApprovedLineItemSummariesView} />
            <Route exact path="/internalMultiClientUsers" component={InternalMultiClientUsersView} />
            <Route exact path="/migration/clientUsers" component={ClientContactsMigrationView} />

            <Route
              exact
              path="/logout"
              render={() => {
                auth.logout();
                return null;
              }}
            />
            <Redirect from="*" to="/intakeRecords" />
          </Switch>
          {profile && (
            <PasswordResetDialog
              open={showPasswordReset}
              error={passwordResetError}
              disabled={isSubmittingPasswordReset}
              onCancel={() => this.setState({ showPasswordReset: false, passwordResetError: null })}
              onSubmit={this.handlePasswordResetRequest}
              email={profile.email}
            />
          )}
          {showImport && (
            <ImportIntakeRecordDialog
              open={showImport}
              error={importError}
              disabled={isImportingRecord}
              onCancel={() => this.setState({ showImport: false, importError: null })}
              onSubmit={this.handleImportRequest}
            />
          )}
        </main>
      </div>
    );
  }
}

AuthenticatedRoutes.propTypes = {
  width: PropTypes.string,
  classes: PropTypes.object.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  theme: PropTypes.object.isRequired,
  title: PropTypes.string,
  apiVersion: PropTypes.string,
  shouldShowSideDrawer: PropTypes.bool.isRequired,
  showSideDrawer: PropTypes.func.isRequired,
  hideSideDrawer: PropTypes.func.isRequired,
  showToast: PropTypes.func.isRequired,
  getUserProfile: PropTypes.func.isRequired,
  getApiVersion: PropTypes.func.isRequired,
  profile: PropTypes.object,
  isImportingRecord: PropTypes.bool.isRequired,
  importIntakeRecord: PropTypes.func.isRequired,
  getIntakeSummaries: PropTypes.func.isRequired,
  getRelocationConsultants: PropTypes.func.isRequired,
  getFirebaseToken: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { profile } = state.auth;
  const { title, shouldShowSideDrawer, apiVersion } = state.layout;
  const { isImportingRecord } = state.intake;
  const { currentAuthId, authorizationDetails, currentVendorId } = state.authorizations;
  const { currentClientId, clientsInfo } = state.clients;
  const { voucherId, expenseId, recurringPayableId } = state.expenses;
  const { currentSurveyQuestionId } = state.surveys;
  const { currentTemplateId } = state.templates;
  const { feeRecordId } = state.fees;

  return {
    title,
    shouldShowSideDrawer,
    apiVersion,
    profile,
    isImportingRecord,
    currentAuthId,
    currentClientId,
    clientsInfo,
    authorizationDetails,
    currentVendorId,
    voucherId,
    expenseId,
    recurringPayableId,
    currentSurveyQuestionId,
    currentTemplateId,
    feeRecordId
  };
};

export default compose(
  withStyles(styles, { withTheme: true }),
  withWidth(),
  withRouter,
  connect(mapStateToProps, {
    showSideDrawer,
    hideSideDrawer,
    showToast,
    getUserProfile,
    importIntakeRecord,
    getIntakeSummaries,
    getRelocationConsultants,
    getApiVersion,
    getFirebaseToken,
    sendMaintencanceObjection
  })
)(AuthenticatedRoutes);
